import * as React from 'react'
import {addYears} from 'date-fns'
import {useSafeCallbackExtraDeps, unCallbackFn} from '@freckle/react-hooks'
import isEqual from 'lodash/isEqual'

import {
  type TeacherLicenseAllocationPostT,
  type LicenseAllocationSubjectT
} from '@frontrow/console/src/models/teacher-license-allocation'
import NewLicense from '@frontrow/console/src/components/pages/teachers-page/teacher-licenses/new-license/new-license'

type Props = {
  createTeacherLicense: (newLicense: TeacherLicenseAllocationPostT) => void
  onCancel: () => void
}

export default function NewLicenseContainer(props: Props): React.ReactElement {
  const [subjectVal, setSubjectVal] = React.useState<LicenseAllocationSubjectT>('math')
  const [startsAtVal, setStartsAtVal] = React.useState<Date>(new Date())
  const [expiresAtVal, setExpiresAtVal] = React.useState<Date>(addYears(new Date(), 1))
  const subjects: Array<[LicenseAllocationSubjectT, string]> = [
    ['math', 'Math'],
    ['ela', 'ELA'],
    ['social_studies', 'Social Studies'],
    ['science', 'Science']
  ]

  const onSubjectChange = (subjectVal: LicenseAllocationSubjectT) => {
    setSubjectVal(subjectVal)
  }

  const onStartsAtChange = (startsAtVal?: Date | null) => {
    if (startsAtVal) {
      setStartsAtVal(startsAtVal)
    }
  }

  const onExpiresAtChange = (expiresAtVal?: Date | null) => {
    if (expiresAtVal) {
      setExpiresAtVal(expiresAtVal)
    }
  }

  const onSubmit = useSafeCallbackExtraDeps<
    (e: React.FormEvent<HTMLFormElement>) => void,
    {
      createTeacherLicense: (newLicense: TeacherLicenseAllocationPostT) => void
      subjectVal: LicenseAllocationSubjectT
      startsAtVal: Date
      expiresAtVal: Date
    }
  >(
    ({createTeacherLicense, subjectVal, startsAtVal, expiresAtVal}) =>
      (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        const newLicense = {
          subject: subjectVal,
          startsAt: startsAtVal,
          expiresAt: expiresAtVal
        }

        createTeacherLicense(newLicense)
      },
    [],
    {
      createTeacherLicense: {value: props.createTeacherLicense, comparator: () => true},
      subjectVal: {value: subjectVal, comparator: isEqual},
      startsAtVal: {value: startsAtVal, comparator: isEqual},
      expiresAtVal: {value: expiresAtVal, comparator: isEqual}
    }
  )

  const onAddAll = () => {
    subjects.forEach(subject => {
      props.createTeacherLicense({
        subject: subject[0],
        startsAt: startsAtVal,
        expiresAt: expiresAtVal
      })
    })
  }

  return (
    <NewLicense
      subjects={subjects}
      subjectVal={subjectVal}
      onSubjectChange={onSubjectChange}
      startsAtVal={startsAtVal}
      onStartsAtChange={onStartsAtChange}
      expiresAtVal={expiresAtVal}
      onExpiresAtChange={onExpiresAtChange}
      onSubmit={unCallbackFn(onSubmit)}
      onAddAll={onAddAll}
      onCancel={props.onCancel}
    />
  )
}
